
interface PlaceholderContentProps {
  activePage: string;
}

const PlaceholderContent = ({ activePage }: PlaceholderContentProps) => {
  // Si c'est la page calendrier, nous n'affichons pas le placeholder
  // car nous avons implémenté cette page
  
  return (
    <div className="text-center py-12 bg-pastel-blueLight dark:bg-[#121624] h-full flex items-center justify-center">
      <div className="max-w-md px-6 py-10 rounded-xl bg-white/70 dark:bg-[#1a1d2d]/50 backdrop-blur-sm shadow-sm border border-gray-100 dark:border-gray-800/30">
        <h3 className="text-lg font-medium text-custom-dark dark:text-gray-200 mb-3 font-sans">
          {activePage === 'publication' ? 'Page de publication' : 
          activePage === 'library' ? 'Page de librairie' : 
          activePage === 'content' ? 'Page de contenu' : 
          activePage === 'analytics' ? 'Page d\'analytique' : 
          activePage === 'roi' ? 'Page de Social Media ROI' : 
          activePage === 'monitoring' ? 'Page de veille' : 
          activePage === 'inbox' ? 'Page de boîte de réception' : 
          'Cette fonctionnalité sera bientôt disponible'}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 font-sans">
          Cette page est en cours de développement.
        </p>
      </div>
    </div>
  );
};

export default PlaceholderContent;
